/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';

import Typography, { TypographyProps } from './Typography';

import styles from '../../styles/typography/header-description.module.css';

interface HeaderDescriptionProps extends TypographyProps {}

function HeaderDescription({ tag = 'div', className, ...props }: HeaderDescriptionProps) {
    return (
        <Typography
            tag={tag}
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
            {...props}
        />
    );
}

export default HeaderDescription;
